import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
    makeRequest,
    dispatchAction,
    displayMessage
} from 'actions';
import {Row, Col, Form, FormGroup, Checkbox, Modal, ControlLabel, FormControl, Button} from 'react-bootstrap';
import Select   from 'react-select'
import {onRowSelect,onAllRowSelect,customMultiSelect} from 'util/Utils';
import {
    FETCH_ADMIN_ORDERS,
} from "actions/actionTypes";
import json2csv   from 'json2csv'
import moment from 'moment'
import queryString from 'query-string'
import PaginationBox from'shared/PaginationBox';
import {prepareSelectOptionsList} from 'util/Utils';
import AdminOrdersListTable from 'dashboard/orders/AdminOrdersListTable';
import AdminOrdersSearchBox from 'dashboard/orders/AdminOrdersSearchBox'
import AdminOrdersActionsBox from 'dashboard/orders/AdminOrdersActionsBox'

import config from  '../../../config';
import {validateEmail}  from 'util/Utils';
import RemoveModalDialog from'shared/RemoveModalDialog';


class AdminOrdersPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
             showModal: false,
            currentPage: _.isUndefined(this.props.location.query.page) ? 0 : parseInt(this.props.location.query.page) - 1,
            errors: {},
            recordIDs:[],
            sortBy: '',
            perPage: config.table.numberPerPage,
            currentRecord:{},
            formData:{},
        };
    };

    componentWillMount() {
        let queryParams = queryString.parse(this.props.location.search);
        console.log('queryParams', queryParams);
        let params = {
            'page': _.isUndefined(queryParams.page) || parseInt(queryParams.page) <= 1 ? 1 : parseInt(queryParams.page),
            perPage: _.isUndefined(queryParams.perPage) ? config.table.numberPerPage : parseInt(queryParams.perPage),
            sortBy: queryParams.sortBy,
            doNotUpdateUrlString: true,
        }
        this.setState({...this.state, ...params})
        if (!_.isUndefined(queryParams.searchText)) {
            params.searchText = queryParams.searchText
        }
        this.search(params)
    }


    editRecord(row) {
        this.setState({
            showModal: true,
            currentRecord: {
                ...row,
            },
        });
    }

    closeModal() {
        this.setState({
            showModal: false,
            currentRecord: {},
        });
    }

    showRemoveDialog(row) {
        this.setState({removeModalVisible: true, currentRecord: row});
    }


    deleteRecord() {
        this.setState({removeModalVisible: false});
        var methodData = {
            type: 'delete',
            "endpoint": "/orders",
            messageData: {'#1#': 'Record'},
            messageCode: 'recordDeleted',
        };
        this.props.makeRequest({id: this.state.currentRecord._id}, methodData).then(res => {
            this.setState({currentRecord: {}});
            this.search()
        }).catch(err => {
            this.setState({currentRecord: {}});
            console.log('e', err);
        });

    }

    validateAndGetFormData() {
        var formData = _.pick(this.state.formData, ['Status'])

        // if (formData.Status) {
        //     this.setState({
        //         errors: {
        //             ...this.state.errors,
        //             Status: true
        //         }
        //     }, () => this.props.displayMessage({
        //         'messageType': 'warning',
        //         'messageCode': 'errorFieldNotSpecified',
        //         messageData: {'#1#': 'Status'}
        //     }));
        //     return false
        // }

        return formData
    }

    saveRecord() {
        var self = this;
        this.setState({pending: true});
        var formData = this.validateAndGetFormData();
        if (!formData) {
            this.setState({pending: false});
            return false;
        }

        var methodData = {
            "endpoint": "/orders" + '/' + encodeURIComponent(this.state.currentRecord._id),
            type: "patch",
        };
        self.props.makeRequest(formData, methodData).then(recordUpdateResponse => {
            self.setState({formData:{}, pending: false});

            self.search({page:self.state.currentPage+1})
            self.closeModal()
        }).catch(err => {
            self.setState({pending: false});
        });
    }


    onSortChange(field, sortOrder) {
        console.log('field', field);
        this.setState({sortBy: field + ':' + (sortOrder == 'asc' ? 1 : -1)}, function () {
            this.refs.pagination.resetPagination();
            this.search()
        })
    }

    search(params = {}) {
        console.log('search  ', params    );
        if (this.state.pending){
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please wait till search request is completed'
            });
        }
        this.setState({pending:true})
        if (this.searchBox) {
            var {queryParams} = this.searchBox.getSearchParams();
        } else {
            var queryParams = {}
        }
        _.extend(queryParams, params);


        if (this.state.sortBy) {
            queryParams.sortBy = this.state.sortBy;
        } else {
            queryParams.sortBy = 'PickupNumber' + ':' + (-1);
        }
        queryParams.lookup = ['OrderTransactions']
        queryParams.sortBySecondary = '_id:-1';
        /* without secondary sort query, the order of documents with the same fields is not guaranteed across pages */

        var methodData = {
            "endpoint": "/orders",
            'not_display_success_message': true,
            'success_event': FETCH_ADMIN_ORDERS
        };

        if (_.isUndefined(params.doNotUpdateUrlString)) {
            const stringified = queryString.stringify(_.omit(queryParams, ['include', 'lookup', 'all','sortBySecondary']));
            this.context.router.push('/admin/orders?' + stringified);
        }
        queryParams.lookup = ['Buyers', 'Users' ]
        queryParams.addFields =  ['FulfilledAt','WarehousePickupReminderSent','WarehousePickupUserResponse']

        return this.props.makeRequest(queryParams, methodData).then(res => {
            this.setState({pending:false})
            if (this.refs.pagination && _.isUndefined(queryParams.page)) {
                console.log('before reset pagination');
                this.refs.pagination.resetPagination();
            }
        }).catch(err => {
            this.setState({pending:false})
        });
    }
    cancelRecord(row) {
        var self  = this;
        var methodData = {
            "endpoint": "/orders"  + '/' + encodeURIComponent(row._id),
            type: "patch",
        };
        self.props.makeRequest({Status:'Cancelled',changeLogs:[ {
            FieldChanged: 'Status',
            By: 'admin',
            AdminFirstName:_.get(this.props.userReducer, 'user.firstName','n/a'),
            From: row.Status,
            To: 'Cancelled',
        }]}, methodData).then(response => {
            self.search()
        }).catch(err => {
        });

    }
    downloadReport(){
        var methodData = {
            "endpoint": "/create-report",
            'type':'post',
            'not_display_success_message':true,
            overrideServerBaseURL: config.getEnvironment().directServerBaseURL,
        };
        if (_.size(this.state.recordIDs)==0){
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Records for report not selected'
            });
        }
        this.props.makeRequest( {
            reportType:'orders',
            'records': this.state.recordIDs,
            all:true,
            sortBy: 'UserID.email' + ':' + (-1),
        }, methodData).then(res => {

            var fields = _.map(_.get(this.actionsBox, 'state.reportFields'), function (field) {
                return _.extend({}, field, {default: ''});
            })
            var dataToExport  = _.map(res.data, function (record) {
                 if (_.get(record, 'CustomData.OrderID') || _.get(record, 'CustomData.OrderNumber')) {
                     if (_.get(record, 'CustomData.OrderID')) {
                         record.ShopifyOrderLink = config.getEnvironment().shopify.orderUrlTemplate.replace("[link_value]", _.get(record, 'CustomData.OrderID'))
                     } else {
                         record.OrderNumber = config.getEnvironment().shopify.shopUrl + '/admin/orders.json?name=%23' + _.get(record, 'CustomData.OrderNumber') + '&status=any'
                     }
                 }
                record.OrderNumber= _.get(record,'CustomData.OrderNumber')
                 record.Status= _.startCase(record.Status)
                 if (_.get(record, 'FulfilledAt.Date')){
                    record.FulfilledDate = moment(_.get(record, 'FulfilledAt.Date')).format("YYYY-MM-DD-HH-mm")
                }
                if (_.get(record, 'WarehousePickupReminderSent.0.createdAt')){
                    record.WarehousePickupReminderSentData = moment(_.get(record, 'WarehousePickupReminderSent.0.createdAt')).format("YYYY-MM-DD-HH-mm")
                }
                if (_.size(_.get(record, 'WarehousePickupUserResponse',[]))){
                    record.WarehousePickupUserResponseData =_.get(record, 'WarehousePickupUserResponse.0.CustomData.UserResponseMessage', '1') + ' ' + moment(_.get(record, 'WarehousePickupUserResponse.0.createdAt')).format("YYYY-MM-DD-HH-mm")
                }
                if (_.size(_.get(record, 'Notifications',[]))){
                    record.Messages =  JSON.stringify(record.Notifications)
                }
                if (_.size(_.get(record, 'ChangeLog',[]))){
                    record.ChangeLogs =  JSON.stringify(record.ChangeLog)
                }
                record.createdAt = moment(record.createdAt).format("YYYY-MM-DD-HH-mm")
                record.UserFullName =   _.get(record, ['UserID', 'firstName'], '') + ' ' + _.get(record, ['UserID', 'lastName'], '')
                     return record
                 })
console.log('dataToExport', dataToExport  );
            console.log('fields', fields  );
            var csvData = json2csv.parse(dataToExport, {
                fields: fields,
                unwindPath: 'UserID'
            })

            var filename = "users_report" +  moment().format("YYYY-MM-DD-HH-mm")+ ".csv";
            var blob = new Blob([csvData], {type: 'text/csv;charset=utf-8;'});
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, filename);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", filename);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }

        }).catch(err => {
            console.log('err', err );
        });
    }
    toggleAllRecordsSelection(value) {
        if (this.state.selectAllRecords) {
            this.setState({recordIDs: [], selectAllRecords: false});
        }else {
            this.search({include: ['_id'], all: true}).then(response => {
                console.log('response.data', response.data  );
                this.setState({recordIDs: _.map(response.data.data, '_id'), selectAllRecords: true});
            })
        }
    }
    render() {
      //  console.log('AdminOrdersPage this state', this.state);

        return (
            <div >
                <AdminOrdersActionsBox
                    ref={(actionsBox) => {
                        if (actionsBox && !this.actionsBox) {
                            this.actionsBox = actionsBox;
                        }
                    } }
                    downloadReport={this.downloadReport.bind(this)}  {...this.props} ></AdminOrdersActionsBox>
                <AdminOrdersSearchBox pending={this.state.pending}
                                      ref={(searchBox) => {
                        if (searchBox && !this.searchBox) {
                            this.searchBox = searchBox;
                          //  this.search({page:this.state.currentPage+1})
                        }
                    } }
                     selectAllRecords = {this.state.selectAllRecords}
                    toggleAllRecordsSelection = {this.toggleAllRecordsSelection.bind(this)}
                    search={this.search.bind(this)}
                    {...this.props} ></AdminOrdersSearchBox>
                {this.props.adminOrders.fetched &&
                <div>
                    {this.props.adminOrders.total == 0 ?
                        <div
                            className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'records')}</div> :
                        <div className="top20">

                            <AdminOrdersListTable
                                onSortChange={this.onSortChange.bind(this)}
                                showRemoveDialog={this.showRemoveDialog.bind(this)}
                                editRecord={this.editRecord.bind(this)}
                                onRowSelect ={onRowSelect.bind(this)}
                                onAllRowSelect ={onAllRowSelect.bind(this)}
                                customMultiSelect ={customMultiSelect.bind(this)}
                                search={this.search.bind(this)} {...this.props}  ></AdminOrdersListTable>
                            <PaginationBox
                                currentPage={_.isUndefined(queryString.parse(this.props.location.search).page) ? 0 : parseInt(queryString.parse(this.props.location.search).page) - 1}
                                perPage={this.refs.searchBox ? this.refs.searchBox.state.filterOptions.perPage : _.get(queryString.parse(this.props.location.search), ['perPage'], undefined)}
                                ref={'pagination'}
                                total={this.props.adminOrders.total == 'initial' ? 0 : this.props.adminOrders.total}
                                search={this.search.bind(this)}>
                            </PaginationBox>

                        </div>}
                </div>
                }

                <Modal onExited={this.closeModal.bind(this)} show={this.state.showModal}
                       onHide={(e) => this.setState({showModal: false})}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.currentRecord._id ? 'Edit' : 'Add new'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form  >
                            <FormGroup>
                                <ControlLabel>Status</ControlLabel>
                                <Select
                                    tabIndex="0"
                                    clearable={false}
                                    placeholder=""
                                    options={  [
                                        {value: 'Unplucked', label: 'Un-Plucked'},
                                        {value: 'Plucked', label: 'Plucked'},
                                    //    {value: 'Pending', label: 'Pending'},
                                        {value: 'Fulfilled', label: 'Fulfilled'},
                                        {value: 'PendingCancellation', label: 'Pending Cancellation'},
                                        {value: 'Cancelled', label: 'Cancelled'},
                                    ]}
                                    onChange={(option) => this.setState({
                                        'formData': {
                                            ...this.state.formData,
                                            Status: option.value
                                        }
                                      })}
                                    value={_.get(this.state, 'formData.Status', _.get(this.state.currentRecord, 'Status'))}
                                />
                            </FormGroup>
                            <FormGroup>
                                <ControlLabel>Email</ControlLabel>
                                <FormControl type="text"
                                             onChange={(e) => this.setState({
                                                 'currentRecord': {
                                                     ...this.state.currentRecord,
                                                     Email: e.target.value
                                                 }
                                             })}
                                             value={this.state.currentRecord.Email }
                                             placeholder="Email"/>
                            </FormGroup>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="top20">
                        <Row className="left0">
                            <Col md={12} sm={12} xs={12} className="pleft0">
                                <Button className=" right0 pull-right btn btn-primary " type="button"
                                        onClick={this.saveRecord.bind(this) }>
                                    Save
                                </Button>
                                <Button className="pull-right btn right20 btn-default" type="button"
                                        onClick={(e) => this.closeModal() }>
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Modal.Footer>
                </Modal>

                <RemoveModalDialog
                    show={this.state.removeModalVisible}
                    removeRecord={(e) => this.deleteRecord() }
                    closeModal={(e) => this.setState({currentRecord: false, removeModalVisible: false})}>
                </RemoveModalDialog>
            </div >
        );

    }
}

function mapStateToProps(state, props) {
    return {
        userReducer: state.userReducer,
        adminOrders:state.adminOrders
     };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminOrdersPage);
